var map = {
	"./promo_00.jpg": 56,
	"./promo_01.jpg": 5057,
	"./promo_02.jpg": 5058,
	"./promo_03.jpg": 55,
	"./promo_04.jpg": 5059,
	"./promo_05.jpg": 5060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5056;